// extracted by mini-css-extract-plugin
export var deleteModal = "_i8-0";